module.exports = __webpack_public_path__ + "static/media/Tropical-sunset.12710409.svg";